<script>
    // @ts-nocheck
    import {
        FormBoxContainer,
        FormBoxRow,
        FormBoxCell,
    } from '$lib/components/UI'
    import dictionaries from '../../stores/dictionaries'
    export let data = {}

    const titlesRef = {
        dp: 'Datos del Proveedor',
        ii: 'Información Impositiva',
        lp: 'Información Laboral y Previsional',
        ac: 'Información Bancaria',
    }

    const schema = {
        tipo_persona_dp: 'Tipo de persona',
        nombre_dp: 'Nombre',
        apellido_dp: 'Apellido',
        denominacion_dp: 'Denominacion Social',
        tipo_doc_dp: 'Tipo de documento',
        no_doc_dp: 'Nro de Documento',
        nombre_fantasia_dp: 'Nombre Fantasia',
        actividad_principal_dp: 'Actividad Principal',
        domicilio_dp: 'Domicilio',
        localidad_dp: 'Localidad',
        cp_dp: 'Codigo Postal',
        tel_dp: 'Telefono',
        email_dp: 'Email',
        tipo_proveedor_ii: 'Tipo de proveedor',
        cuit_ii: 'CUIT',
        condicion_imp_iva_ii: 'Condicion de IVA',
        condicion_imp_ganancias_ii: 'Condicion de Ganancias',
        condicion_imp_ingresos_ii: 'Condicion de Ingresos Brutos',
        no_ingresos_brutos_ii: 'Nro de Ingresos Brutos',
        empleador_ii: 'Empleador',
        tiene_personal_lp: 'Tiene Personal',
        banco_ac: 'Banco',
        // 'sucursal_ac': 'Sucursal',
        titular_ac: 'Titular de cuenta',
        cuit_ac: 'CUIT',
        cbu_ac: 'CBU',
        domicilio_ac: 'Domicilio',
        tel_ac: 'Telefono',
        fax_ac: 'Fax',
        email_ac: 'Email',
        presentado_ac: 'Presentado Por',
        tipo_doc_dp: 'Tipo de documento',
        tipo_doc_ac: 'Tipo de documento',
        no_doc_ac: 'Nro de Documento',
    }

    const getLabelValueBuilder = (dict) => (t) =>
        $dictionaries[dict]?.find(({ value }) => value == t)?.label
    const caster = (key) => {
        let ref = {
            tipo_proveedor_ii: getLabelValueBuilder('tipo_proveedor'),
            condicion_imp_iva_ii: getLabelValueBuilder('condicion_iva'),
            condicion_imp_ganancias_ii: getLabelValueBuilder(
                'condicion_ganancias'
            ),
            condicion_imp_ingresos_ii:
                getLabelValueBuilder('posicion_ingresos'),
            tipo_doc_dp: getLabelValueBuilder('tipo_documento'),
            tipo_doc_ac: getLabelValueBuilder('tipo_documento'),
            banco_ac: getLabelValueBuilder('bancos'),
            tiene_personal_lp: getLabelValueBuilder('booleano'),
            empleador_ii: getLabelValueBuilder('empleador'),
            tipo_persona_dp: (_) =>
                data?.persona_jur_dp ? 'Jurídica' : 'Humana',
        }
        return key in ref ? ref[key] : (t) => t
    }
    $: categorizedFields = Object.keys(titlesRef)
        .map((K) => [
            K,
            Object.entries(schema).filter(([k]) => k.substr(-2) === K),
        ])
        .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
</script>

<br />
<!-- {#if Object.keys(data).some(x => x.substr(-2) == 'dp')}
    <FormBoxContainer title="Datos del Proveedor">
        <FormBoxRow>
            <FormBoxCell label="Tipo de persona" value={data.persona_hum_dp ? 'Humana' : 'Jurídica'}/>
        </FormBoxRow>
        <FormBoxRow>
            <FormBoxCell
                label="Tipo de documento"
                value={$dictionaries.tipo_documento?.find(({value}) => value == data.tipo_doc_dp)?.label || '-'}
            />
            <FormBoxCell label="Nro. Documento" value={data.no_doc_dp || '-'}/>
        </FormBoxRow>
    </FormBoxContainer>
    <br/>
{/if} -->

{#each Object.entries(categorizedFields) as [id, fields]}
    <FormBoxContainer title={titlesRef[id]}>
        {#each fields as [value, label]}
            <FormBoxRow>
                <FormBoxCell
                    {label}
                    value={caster(value)(data[value]) || '-'}
                />
            </FormBoxRow>
        {/each}
    </FormBoxContainer>
    <br />
{/each}
